export const getRouter = state => state.router;
export const getUser = state => state.user;
export const getEntityRepository = state => state.entityRepository;
export const getDiagnostic = state => state.diagnostic;
export const getLocaleConfig = state => state.localeConfig;
export const getModal = state => state.modal;
export const getForm = state => state.form;



// WEBPACK FOOTER //
// ./src/modules/root/root-selectors.js